import type { ContourTexture } from '~/engine/data/structure/ContourTexture';
import type { ReadonlyVec3 } from 'gl-matrix';

export type CrossSectionErrorCode =
    | 'no-sections'
    | 'too-few-vertices'
    | 'outside-image'
    | 'degenerate-rank'
    | 'gl-busy'
    | 'empty-result'
    | 'invalid-parameter';

export class CrossSectionError extends Error {
    public constructor(
        public readonly code: CrossSectionErrorCode,
        message: string
    ) {
        super(message);
        Object.setPrototypeOf(this, CrossSectionError.prototype);
        this.name = 'CrossSectionError';
    }
}

export interface CrossSectionPlane {
    readonly originMm: ReadonlyVec3;
    readonly normal: ReadonlyVec3;
}

export interface CrossSectionInput {
    readonly plane: CrossSectionPlane;
    readonly polygonsMm: readonly (readonly ReadonlyVec3[])[];
}

export interface ReconstructionOptions {
    readonly signal?: AbortSignal;
}

export interface ConnectivityReport {
    readonly componentCount: number;
    readonly componentVolumesMm3: readonly number[];
}

export interface ReconstructionResult {
    readonly texture: ContourTexture;
    readonly connectivity: ConnectivityReport;
    readonly maxResidualMm: number;
    readonly centreCount: number;
    readonly toleranceMet: boolean;
    readonly isSlab: boolean;
}
